import { Link } from "react-router-dom";

const Legal = () => {
  const currentYear = new Date().getFullYear();
  return (
    <div className="container mx-auto px-4 py-10 prose prose-invert max-w-3xl">
      <h1 className="text-3xl font-bold mb-6">Mentions légales, CGU et Politique de confidentialité</h1>
      <p className="text-sm text-muted-foreground">Dernière mise à jour: {new Date().toLocaleDateString()}</p>

      <h2 className="mt-10 text-2xl font-semibold">1. Éditeur du site</h2>
      <p>
        Ce site est édité par Beemm ("nous"). Pour toute question, merci de nous contacter via la page
        <span> </span>
        <a href="#contact" className="underline underline-offset-4">Contact</a>.
      </p>

      <h2 className="mt-10 text-2xl font-semibold">2. Objet du service</h2>
      <p>
        Beemm Enhancer est une application web permettant d'améliorer des images à l'aide de modèles d'IA. Les
        transformations sont réalisées par des services cloud (notamment Firebase et des fournisseurs IA tiers) et les
        résultats peuvent être stockés sur des serveurs distants.
      </p>

      <h2 className="mt-10 text-2xl font-semibold">3. Comptes et accès</h2>
      <ul>
        <li>Authentification via Firebase (Google et email/mot de passe).</li>
        <li>Vous êtes responsable de la confidentialité de vos identifiants et de l'activité réalisée sur votre compte.</li>
        <li>Un rôle administrateur peut gérer des paramètres avancés de l'application.</li>
      </ul>

      <h2 className="mt-10 text-2xl font-semibold">4. Abonnements et paiements</h2>
      <ul>
        <li>Le paiement est géré par Stripe. Nous ne stockons pas vos données de carte.</li>
        <li>Les abonnements Classic/Pro donnent accès à des fonctionnalités et crédits mensuels.</li>
        <li>La facturation et l'historique sont consultables dans votre espace compte.</li>
      </ul>

      <h2 className="mt-10 text-2xl font-semibold">5. Contenus générés par l'IA</h2>
      <ul>
        <li>Vous conservez vos droits sur les images que vous importez.</li>
        <li>Vous garantissez détenir les droits nécessaires sur les contenus soumis.</li>
        <li>Les résultats générés peuvent présenter des imperfections inhérentes aux modèles IA.</li>
        <li>Les contenus illicites, offensants ou violant des droits de tiers sont interdits.</li>
      </ul>

      <h2 className="mt-10 text-2xl font-semibold">6. Données personnelles</h2>
      <p>
        Nous utilisons Firebase (Auth, Firestore, Storage) pour fournir le service. Certaines informations (email,
        identifiant utilisateur, état d'abonnement, historique de facturation) sont traitées pour l'exécution du
        contrat et l'amélioration du service. Les images importées et générées peuvent être conservées pour vous
        permettre de les consulter et pour assurer la qualité du service.
      </p>
      <p>
        Les sous-traitants principaux sont Google Firebase et Stripe. Les données peuvent être hébergées dans l'Union
        européenne et/ou aux États‑Unis, selon la topologie de nos services.
      </p>

      <h2 className="mt-10 text-2xl font-semibold">7. Cookies et traceurs</h2>
      <p>
        Nous utilisons des cookies strictement nécessaires au fonctionnement (authentification, préférences, sécurité),
        ainsi que des cookies optionnels (analyse d'usage, marketing) soumis à votre consentement. Vous pouvez gérer vos
        préférences à tout moment via la page <Link to="/cookies" className="underline underline-offset-4">Préférences cookies</Link>.
      </p>

      <h2 className="mt-10 text-2xl font-semibold">8. Sécurité</h2>
      <p>
        Nous mettons en œuvre des mesures raisonnables pour protéger vos données (règles de sécurité Firebase,
        restrictions CORS, isolation des secrets). Aucun système n'étant infaillible, nous ne pouvons garantir une
        sécurité absolue.
      </p>

      <h2 className="mt-10 text-2xl font-semibold">9. Limitation de responsabilité</h2>
      <p>
        Le service est fourni « en l'état ». Nous ne saurions être tenus responsables des pertes indirectes,
        immatérielles, ou consécutives à l'utilisation du service, dans la limite permise par la loi.
      </p>

      <h2 className="mt-10 text-2xl font-semibold">10. Résiliation</h2>
      <p>
        Nous pouvons suspendre ou résilier un compte en cas de violation des présentes ou d'usage frauduleux. Vous
        pouvez résilier votre abonnement à tout moment via le portail Stripe.
      </p>

      <h2 className="mt-10 text-2xl font-semibold">11. Droit applicable</h2>
      <p>
        Les présentes sont soumises au droit applicable dans votre pays de résidence ou, à défaut, au droit français.
      </p>

      <hr className="my-8 opacity-20" />
      <p className="text-xs text-muted-foreground">© {currentYear} Beemm — Tous droits réservés.</p>
    </div>
  );
};

export default Legal;


